import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  className?: string;
}

const OldDreamupLogo: FC<Props> = ({ className }) => {
  const { t } = useTranslation();
  return (
    <a href="https://www.deviantart.com/dreamupzone">
      <img
        className={className}
        src="https://st.deviantart.net/dreamup/old-du-light.png"
        alt={t('stash.dreamup.logo.alt')}
      />
    </a>
  );
};
OldDreamupLogo.displayName = 'OldDreamupLogo';

export default OldDreamupLogo;
